<template lang="pug">
    v-dialog( persistent max-width="700px" v-model="open" )
        v-toolbar( color="primary" dark sticky flat )
            v-toolbar-title Creación de libro de compra y venta
            v-spacer
            v-btn( icon dark @click="toggleOpen")
                v-icon close
        v-container( fluid grid-list-lg )
            v-layout( row wrap )
                v-flex( xs12 sm6 )                
                    model-autocomplete(
                        v-bind='autocompleteProps'
                        v-model='branchOffice'
                        )
                v-flex( xs12 sm6 )
                    v-dialog(
                        ref="dialogCreatePchSaleBook"
                        v-model="modal"
                        :return-value.sync="date"
                        persistent
                        lazy
                        full-width
                        width="290px"
                        )
                        v-text-field(
                            slot="activator"
                            v-model="date"
                            label="Indique Período"
                            prepend-icon="event"
                            readonly
                            )
                        v-date-picker(v-model="date" type="month" scrollable locale)
                        v-spacer
                        v-btn(flat color="primary" @click="modal = false") Cancelar
                        v-btn(flat color="primary" @click="submitDate") Aceptar
                v-flex( xs12 text-xs-center )
                    v-btn(
                        color="success" 
                        dark 
                        large
                        @click="submitGeneratePchSaleBook"
                        ) Generar libro compra venta
        loading-dialog(:loading="loadingData")
</template>

<script>
import { mapActions, mapState } from 'vuex'
import LoadingDialog from '@/components/reusable_components/LoadingDialog/LoadingDialog'
import ModelAutocomplete from '@/components/reusable_components/next/ModelAutocomplete'
import { createPurchaseSaleBook } from '@/services/api/purchaseSaleBook'
import GBranchOfficeModel from '@/models/General/GBranchOffice'
export default {
    name: 'dialog-generate-pch-sale-book',
    // props: {},
    data: function() {
        return {
            open: false,
            date: null,
            menu: false,
            modal: false,
            loadingData: false,
            branchOffice: null,
        }
    },
    computed: {
        ...mapState('SnackbarModalModule', {
            responseConfirm: 'responseConfirm',
        }),

        /**
         * 
         */
        autocompleteProps() {
            return {
                itemText: 'name',
                itemValue: 'id',
                label: 'Sucursal',
                model: GBranchOfficeModel,
                noObject: true,
                paramSearch: 'name',
                outline: false,
            }
        }
    },
    methods: {
        // -- UI Modification
        submitDate: function() {
            this.$refs.dialogCreatePchSaleBook.save(this.date)
            this.data = this.$refs.dialogCreatePchSaleBook.$options.propsData.returnValue
            // this.getPayroll(this.data)
        },
        submitGeneratePchSaleBook: function() {
            if (this.date !== null && this.date !== '') {
                this.resetSnackbarState()
                this.setMessageConfirmSnack('Generar')
                //-
                this.showSnackbar(
                    'warning',
                    '¿Desea generar libro de compra y venta?',
                    ''
                )
            } else {
                this.resetSnackbarState()
                this.showSnackbar(
                    'error',
                    'Debe ingresar período',
                    ''
                )
            }
        },
        // -- Data fetching
        // -- Data handling and transformations
        // -- Validations and Error handling
        setLoadingDataSpinner(value) {
            this.loadingData = value
        },
        toggleOpen: function() {
            this.open = !this.open
            this.date = ''
        },
        // -- Other functions
        showSnackbar: function(type, title, message) {
            this.initSnackbar(this.fillSnack(type, title, message))
        },
        // -- Vuex mappings
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
    },
    watch: {
        open(val) {
            if (val == true) {
                // 
            }
        },
        async responseConfirm(val) {
            //-
            if (val === 'Generar') {
                this.setLoadingDataSpinner(true)
                this.resetSnackbarState()
                let period = {}
                let branchOffice = this.branchOffice
                period.year = parseInt(this.date.substr(0, 4))
                period.month = parseInt(this.date.substr(5, 2))
                let response = await createPurchaseSaleBook(period, branchOffice)
                //-
                if (response.status == 'success') {
                    this.setLoadingDataSpinner(false)
                    let payload = this.fillSnack(
                        'success',
                        'Libro de compra y venta generado exitosamente',
                        ''
                    )
                    this.initSnackbar(payload)
                    this.$emit('success')
                    this.toggleOpen()
                } else {
                    this.setLoadingDataSpinner(false)
                    let payload = this.fillSnack(
                        'error',
                        'Error',
                        response.error
                    )
                    this.initSnackbar(payload)
                }
            }
        },
    },
    components: {
        ModelAutocomplete,
        'loading-dialog': LoadingDialog,
    },
    // mixins: [],
    // filters: {},
    // -- Lifecycle Methods
    // -- End Lifecycle Methods
}
</script>

<style lang="scss">
</style>